import { LocaleEnum } from '@systemeio/ui'

export const getEmptyLocaleValues = (): Record<LocaleEnum, string> => {
  const localeArr = Object.values(LocaleEnum)
  return localeArr.reduce((acc, lang: LocaleEnum) => {
    acc[lang] = ''
    return acc
  }, {} as Record<LocaleEnum, string>)
}
